/*! For license information please see powerbi-report-authoring.js.LICENSE.txt */
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t(require("powerbi-client")):"function"==typeof define&&define.amd?define(["powerbi-client"],t):"object"==typeof exports?exports["powerbi-report-authoring"]=t(require("powerbi-client")):e["powerbi-report-authoring"]=t(e["powerbi-client"])}(self,(e=>(()=>{var t={913:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.Config=void 0;var r=function(){function e(){}return e.version="2.0.0",e}();t.Config=r},758:(e,t)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.Errors=void 0;var r=function(){function e(){}return e.PowerBIClientIsNotInitialized="powerbi-client module is not initialized. Please import powerbi-client script before importing powerbi-report-authoring.",e}();t.Errors=r},733:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.extensions=void 0;var i=r(856),o=r(230),n=r(379);t.extensions=[new o.ReportExtensions,new i.PageExtensions,new n.VisualExtensions]},856:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.PageExtensions=void 0;var i=r(719),o=r(913),n=r(758),s=function(){function e(){}return e.post=function(t,r,i){var n=e.hpm(t),s=e.uid(t),u=e.contentWindow(t),a=o.Config.version;return n.post(r,i,{uid:s,"x-report-authoring-sdk-version":a},u).then((function(e){return e.body}),(function(e){throw e.body}))},e.contentWindow=function(e){return e.report.iframe.contentWindow},e.uid=function(e){return e.report.config.uniqueId},e.hpm=function(e){return e.report.service.hpm},e.prototype.initialize=function(){null!=i.Page?(i.Page.prototype.createVisual=function(t,r,o){var n=this,s={visualType:t,layout:r,autoFocus:o};return e.post(this,"/report/pages/"+this.name+"/createVisual",s).then((function(e){var t=e.visual;return{visual:new i.VisualDescriptor(n,t.name,t.title,t.type,t.layout)}}),(function(e){throw e}))},i.Page.prototype.deleteVisual=function(t){return e.post(this,"/report/pages/"+this.name+"/deleteVisual",{visualName:t})}):console.error(n.Errors.PowerBIClientIsNotInitialized)},e}();t.PageExtensions=s},230:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.ReportExtensions=void 0;var i=r(719),o=r(913),n=r(758),s=function(){function e(){}return e.get=function(t,r){var i=e.hpm(t),n=e.uid(t),s=e.contentWindow(t),u=o.Config.version;return i.get(r,{uid:n,"x-report-authoring-sdk-version":u},s).then((function(e){return e.body}),(function(e){throw e.body}))},e.contentWindow=function(e){return e.iframe.contentWindow},e.uid=function(e){return e.config.uniqueId},e.hpm=function(e){return e.service.hpm},e.prototype.initialize=function(){null!=i.Report?(i.Report.prototype.getVisualCapabilities=function(t){if(!t)throw{message:"visualType parameter is missing"};return e.get(this,"/report/visuals/types/"+t+"/capabilities")},i.Report.prototype.getAvailableVisualTypes=function(){return e.get(this,"/report/availableVisualTypes")}):console.error(n.Errors.PowerBIClientIsNotInitialized)},e}();t.ReportExtensions=s},379:(e,t,r)=>{Object.defineProperty(t,"__esModule",{value:!0}),t.VisualExtensions=void 0;var i=r(719),o=r(913),n=r(758),s=function(){function e(){}return e.delete=function(t,r,i){return e.sendRequestWithBody(t,"delete",r,i)},e.post=function(t,r,i){return e.sendRequestWithBody(t,"post",r,i)},e.put=function(t,r,i){return e.sendRequestWithBody(t,"put",r,i)},e.sendRequestWithBody=function(t,r,i,n){var s=e.hpm(t),u=e.uid(t),a=e.contentWindow(t),p=o.Config.version;return s[r](i,n,{uid:u,"x-report-authoring-sdk-version":p},a).then((function(e){return e.body}),(function(e){throw e.body}))},e.get=function(t,r){var i=e.hpm(t),n=e.uid(t),s=e.contentWindow(t),u=o.Config.version;return i.get(r,{uid:n,"x-report-authoring-sdk-version":u},s).then((function(e){return e.body}),(function(e){throw e.body}))},e.contentWindow=function(e){return e.page.report.iframe.contentWindow},e.uid=function(e){return e.page.report.config.uniqueId},e.hpm=function(e){return e.page.report.service.hpm},e.prototype.initialize=function(){null!=i.VisualDescriptor?(i.VisualDescriptor.prototype.changeType=function(t){return e.post(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/changeType",{visualType:t})},i.VisualDescriptor.prototype.getCapabilities=function(){return e.get(this,"/report/visuals/types/"+this.type+"/capabilities")},i.VisualDescriptor.prototype.getDataFieldDisplayName=function(t,r){return e.get(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/dataroles/"+t+"/fields/"+r+"/displayName")},i.VisualDescriptor.prototype.setDataFieldDisplayName=function(t,r,i){return e.put(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/dataroles/"+t+"/fields/"+r+"/displayName",{newDisplayName:i})},i.VisualDescriptor.prototype.addDataField=function(t,r,i){return e.post(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/dataroles/"+t+"/fields/"+i,r)},i.VisualDescriptor.prototype.getDataFields=function(t){return e.get(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/dataroles/"+t+"/fields")},i.VisualDescriptor.prototype.removeDataField=function(t,r){var i="/report/pages/"+this.page.name+"/visuals/"+this.name+"/dataroles/"+t+"/fields/"+r;return e.delete(this,i,r)},i.VisualDescriptor.prototype.getProperty=function(t){return e.post(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/property",t)},i.VisualDescriptor.prototype.setProperty=function(t,r){return e.put(this,"/report/pages/"+this.page.name+"/visuals/"+this.name+"/property",{selector:t,value:r})},i.VisualDescriptor.prototype.resetProperty=function(e){return this.setProperty(e,{schema:"http://powerbi.com/product/schema#default",value:{}})}):console.error(n.Errors.PowerBIClientIsNotInitialized)},e}();t.VisualExtensions=s},719:t=>{"use strict";t.exports=e}},r={};function i(e){var o=r[e];if(void 0!==o)return o.exports;var n=r[e]={exports:{}};return t[e](n,n.exports,i),n.exports}var o={};return(()=>{var e=o;Object.defineProperty(e,"__esModule",{value:!0}),e.startAuthoring=void 0;var t=i(733);function r(){t.extensions.forEach((function(e){e.initialize()}))}e.startAuthoring=r,r()})(),o})()));
// SIG // Begin signature block
// SIG // MIIrVQYJKoZIhvcNAQcCoIIrRjCCK0ICAQExDzANBglg
// SIG // hkgBZQMEAgEFADB3BgorBgEEAYI3AgEEoGkwZzAyBgor
// SIG // BgEEAYI3AgEeMCQCAQEEEBDgyQbOONQRoqMAEEvTUJAC
// SIG // AQACAQACAQACAQACAQAwMTANBglghkgBZQMEAgEFAAQg
// SIG // VolPL9xAqyJD917d5AhOgh/seZXSlzMxfKgF9B2s5YWg
// SIG // ghF5MIIIiTCCB3GgAwIBAgITNgAAAanWkDBmQ9sfggAC
// SIG // AAABqTANBgkqhkiG9w0BAQsFADBBMRMwEQYKCZImiZPy
// SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRUw
// SIG // EwYDVQQDEwxBTUUgQ1MgQ0EgMDEwHhcNMjIwNjEwMTgy
// SIG // NzA0WhcNMjMwNjEwMTgyNzA0WjAkMSIwIAYDVQQDExlN
// SIG // aWNyb3NvZnQgQXp1cmUgQ29kZSBTaWduMIIBIjANBgkq
// SIG // hkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuLvS3Hq6XM6N
// SIG // 5ZVPdqZQQbTo4WFo9Ar6TqyLpZIqQpNoW9ZG58deayDX
// SIG // VV7wKgn0IAjewM3VfPGtiX8jjOz4VtelbCYnbV9zrqqU
// SIG // rtTlqTbFB1L+UWQO2DLhxB8QybLxi38KaiY1DC6DL5xK
// SIG // uAnIGWnVNS168FihSxIPneGKfG3nJH1CgSA/rJ7w7tnY
// SIG // 8hHlpPpMia6oKVAZSvos9/fDpBmX+cru3sXfEv19s+4O
// SIG // JKLoPlJiNR0PhsqW5hChTn+tjVOBu8Td7tcb+jf9QQs1
// SIG // 2HPBtx3nMNhNlYZQrqXJMUy65RH2zAYAd9N9tdo6VRU/
// SIG // 8vRYzYOrWHSulDVtMn2cjwIDAQABo4IFlTCCBZEwKQYJ
// SIG // KwYBBAGCNxUKBBwwGjAMBgorBgEEAYI3WwEBMAoGCCsG
// SIG // AQUFBwMDMD0GCSsGAQQBgjcVBwQwMC4GJisGAQQBgjcV
// SIG // CIaQ4w2E1bR4hPGLPoWb3RbOnRKBYIPdzWaGlIwyAgFk
// SIG // AgEMMIICdgYIKwYBBQUHAQEEggJoMIICZDBiBggrBgEF
// SIG // BQcwAoZWaHR0cDovL2NybC5taWNyb3NvZnQuY29tL3Br
// SIG // aWluZnJhL0NlcnRzL0JZMlBLSUNTQ0EwMS5BTUUuR0JM
// SIG // X0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYIKwYB
// SIG // BQUHMAKGRmh0dHA6Ly9jcmwxLmFtZS5nYmwvYWlhL0JZ
// SIG // MlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIwQ0El
// SIG // MjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6Ly9j
// SIG // cmwyLmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5BTUUu
// SIG // R0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYI
// SIG // KwYBBQUHMAKGRmh0dHA6Ly9jcmwzLmFtZS5nYmwvYWlh
// SIG // L0JZMlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIw
// SIG // Q0ElMjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6
// SIG // Ly9jcmw0LmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5B
// SIG // TUUuR0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQw
// SIG // ga0GCCsGAQUFBzAChoGgbGRhcDovLy9DTj1BTUUlMjBD
// SIG // UyUyMENBJTIwMDEsQ049QUlBLENOPVB1YmxpYyUyMEtl
// SIG // eSUyMFNlcnZpY2VzLENOPVNlcnZpY2VzLENOPUNvbmZp
// SIG // Z3VyYXRpb24sREM9QU1FLERDPUdCTD9jQUNlcnRpZmlj
// SIG // YXRlP2Jhc2U/b2JqZWN0Q2xhc3M9Y2VydGlmaWNhdGlv
// SIG // bkF1dGhvcml0eTAdBgNVHQ4EFgQUj5gJWFiDzm06yLnX
// SIG // Wf2V9PM6+1cwDgYDVR0PAQH/BAQDAgeAMFAGA1UdEQRJ
// SIG // MEekRTBDMSkwJwYDVQQLEyBNaWNyb3NvZnQgT3BlcmF0
// SIG // aW9ucyBQdWVydG8gUmljbzEWMBQGA1UEBRMNMjM2MTY3
// SIG // KzQ3MDg2MTCCAeYGA1UdHwSCAd0wggHZMIIB1aCCAdGg
// SIG // ggHNhj9odHRwOi8vY3JsLm1pY3Jvc29mdC5jb20vcGtp
// SIG // aW5mcmEvQ1JML0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5j
// SIG // cmyGMWh0dHA6Ly9jcmwxLmFtZS5nYmwvY3JsL0FNRSUy
// SIG // MENTJTIwQ0ElMjAwMSgyKS5jcmyGMWh0dHA6Ly9jcmwy
// SIG // LmFtZS5nYmwvY3JsL0FNRSUyMENTJTIwQ0ElMjAwMSgy
// SIG // KS5jcmyGMWh0dHA6Ly9jcmwzLmFtZS5nYmwvY3JsL0FN
// SIG // RSUyMENTJTIwQ0ElMjAwMSgyKS5jcmyGMWh0dHA6Ly9j
// SIG // cmw0LmFtZS5nYmwvY3JsL0FNRSUyMENTJTIwQ0ElMjAw
// SIG // MSgyKS5jcmyGgb1sZGFwOi8vL0NOPUFNRSUyMENTJTIw
// SIG // Q0ElMjAwMSgyKSxDTj1CWTJQS0lDU0NBMDEsQ049Q0RQ
// SIG // LENOPVB1YmxpYyUyMEtleSUyMFNlcnZpY2VzLENOPVNl
// SIG // cnZpY2VzLENOPUNvbmZpZ3VyYXRpb24sREM9QU1FLERD
// SIG // PUdCTD9jZXJ0aWZpY2F0ZVJldm9jYXRpb25MaXN0P2Jh
// SIG // c2U/b2JqZWN0Q2xhc3M9Y1JMRGlzdHJpYnV0aW9uUG9p
// SIG // bnQwHwYDVR0jBBgwFoAUllGE4Gtve/7YBqvD8oXmKa5q
// SIG // +dQwHwYDVR0lBBgwFgYKKwYBBAGCN1sBAQYIKwYBBQUH
// SIG // AwMwDQYJKoZIhvcNAQELBQADggEBAHD1OJbFZ/tIa5Zp
// SIG // DzeU+mqWHOdF2htAZKicRfNYhaajjyYRvCTUKn/5SZGU
// SIG // KKdVmsxiFtCOp2lJ2+C3b7IJukkqC9SmpIkQLhBuz7uK
// SIG // 4NsXB6Xn3Iv32YuKeH4sqdRqJMCezhsale/Sh6fecsVW
// SIG // pJnsvfXxdXBCyoVbAZCZCQN3dOXUz4DtEfV2fxhRzTfS
// SIG // UhKsr1VSY9HC/myediSqvqd3zfgK9j6IR0DcL3WkKiV0
// SIG // B/dnYwntnntrhFxGYQuPPXBA7xX10SB/8CVA8V1NovOk
// SIG // tGO5cgvmVMe5pA2m9M7sOBgFkjXgPD7i4PoL5X0mK+6b
// SIG // nchiEZj1C5l1X6LzJH4wggjoMIIG0KADAgECAhMfAAAA
// SIG // UeqP9pxzDKg7AAAAAABRMA0GCSqGSIb3DQEBCwUAMDwx
// SIG // EzARBgoJkiaJk/IsZAEZFgNHQkwxEzARBgoJkiaJk/Is
// SIG // ZAEZFgNBTUUxEDAOBgNVBAMTB2FtZXJvb3QwHhcNMjEw
// SIG // NTIxMTg0NDE0WhcNMjYwNTIxMTg1NDE0WjBBMRMwEQYK
// SIG // CZImiZPyLGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYD
// SIG // QU1FMRUwEwYDVQQDEwxBTUUgQ1MgQ0EgMDEwggEiMA0G
// SIG // CSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDJmlIJfQGe
// SIG // jVbXKpcyFPoFSUllalrinfEV6JMc7i+bZDoL9rNHnHDG
// SIG // fJgeuRIYO1LY/1f4oMTrhXbSaYRCS5vGc8145WcTZG90
// SIG // 8bGDCWr4GFLc411WxA+Pv2rteAcz0eHMH36qTQ8L0o3X
// SIG // Ob2n+x7KJFLokXV1s6pF/WlSXsUBXGaCIIWBXyEchv+s
// SIG // M9eKDsUOLdLTITHYJQNWkiryMSEbxqdQUTVZjEz6eLRL
// SIG // kofDAo8pXirIYOgM770CYOiZrcKHK7lYOVblx22pdNaw
// SIG // Y8Te6a2dfoCaWV1QUuazg5VHiC4p/6fksgEILptOKhx9
// SIG // c+iapiNhMrHsAYx9pUtppeaFAgMBAAGjggTcMIIE2DAS
// SIG // BgkrBgEEAYI3FQEEBQIDAgACMCMGCSsGAQQBgjcVAgQW
// SIG // BBQSaCRCIUfL1Gu+Mc8gpMALI38/RzAdBgNVHQ4EFgQU
// SIG // llGE4Gtve/7YBqvD8oXmKa5q+dQwggEEBgNVHSUEgfww
// SIG // gfkGBysGAQUCAwUGCCsGAQUFBwMBBggrBgEFBQcDAgYK
// SIG // KwYBBAGCNxQCAQYJKwYBBAGCNxUGBgorBgEEAYI3CgMM
// SIG // BgkrBgEEAYI3FQYGCCsGAQUFBwMJBggrBgEFBQgCAgYK
// SIG // KwYBBAGCN0ABAQYLKwYBBAGCNwoDBAEGCisGAQQBgjcK
// SIG // AwQGCSsGAQQBgjcVBQYKKwYBBAGCNxQCAgYKKwYBBAGC
// SIG // NxQCAwYIKwYBBQUHAwMGCisGAQQBgjdbAQEGCisGAQQB
// SIG // gjdbAgEGCisGAQQBgjdbAwEGCisGAQQBgjdbBQEGCisG
// SIG // AQQBgjdbBAEGCisGAQQBgjdbBAIwGQYJKwYBBAGCNxQC
// SIG // BAweCgBTAHUAYgBDAEEwCwYDVR0PBAQDAgGGMBIGA1Ud
// SIG // EwEB/wQIMAYBAf8CAQAwHwYDVR0jBBgwFoAUKV5RXmSu
// SIG // NLnrrJwNp4x1AdEJCygwggFoBgNVHR8EggFfMIIBWzCC
// SIG // AVegggFToIIBT4YxaHR0cDovL2NybC5taWNyb3NvZnQu
// SIG // Y29tL3BraWluZnJhL2NybC9hbWVyb290LmNybIYjaHR0
// SIG // cDovL2NybDIuYW1lLmdibC9jcmwvYW1lcm9vdC5jcmyG
// SIG // I2h0dHA6Ly9jcmwzLmFtZS5nYmwvY3JsL2FtZXJvb3Qu
// SIG // Y3JshiNodHRwOi8vY3JsMS5hbWUuZ2JsL2NybC9hbWVy
// SIG // b290LmNybIaBqmxkYXA6Ly8vQ049YW1lcm9vdCxDTj1B
// SIG // TUVSb290LENOPUNEUCxDTj1QdWJsaWMlMjBLZXklMjBT
// SIG // ZXJ2aWNlcyxDTj1TZXJ2aWNlcyxDTj1Db25maWd1cmF0
// SIG // aW9uLERDPUFNRSxEQz1HQkw/Y2VydGlmaWNhdGVSZXZv
// SIG // Y2F0aW9uTGlzdD9iYXNlP29iamVjdENsYXNzPWNSTERp
// SIG // c3RyaWJ1dGlvblBvaW50MIIBqwYIKwYBBQUHAQEEggGd
// SIG // MIIBmTBHBggrBgEFBQcwAoY7aHR0cDovL2NybC5taWNy
// SIG // b3NvZnQuY29tL3BraWluZnJhL2NlcnRzL0FNRVJvb3Rf
// SIG // YW1lcm9vdC5jcnQwNwYIKwYBBQUHMAKGK2h0dHA6Ly9j
// SIG // cmwyLmFtZS5nYmwvYWlhL0FNRVJvb3RfYW1lcm9vdC5j
// SIG // cnQwNwYIKwYBBQUHMAKGK2h0dHA6Ly9jcmwzLmFtZS5n
// SIG // YmwvYWlhL0FNRVJvb3RfYW1lcm9vdC5jcnQwNwYIKwYB
// SIG // BQUHMAKGK2h0dHA6Ly9jcmwxLmFtZS5nYmwvYWlhL0FN
// SIG // RVJvb3RfYW1lcm9vdC5jcnQwgaIGCCsGAQUFBzAChoGV
// SIG // bGRhcDovLy9DTj1hbWVyb290LENOPUFJQSxDTj1QdWJs
// SIG // aWMlMjBLZXklMjBTZXJ2aWNlcyxDTj1TZXJ2aWNlcyxD
// SIG // Tj1Db25maWd1cmF0aW9uLERDPUFNRSxEQz1HQkw/Y0FD
// SIG // ZXJ0aWZpY2F0ZT9iYXNlP29iamVjdENsYXNzPWNlcnRp
// SIG // ZmljYXRpb25BdXRob3JpdHkwDQYJKoZIhvcNAQELBQAD
// SIG // ggIBAFAQI7dPD+jfXtGt3vJp2pyzA/HUu8hjKaRpM3op
// SIG // ya5G3ocprRd7vdTHb8BDfRN+AD0YEmeDB5HKQoG6xHPI
// SIG // 5TXuIi5sm/LeADbV3C2q0HQOygS/VT+m1W7a/752hMIn
// SIG // +L4ZuyxVeSBpfwf7oQ4YSZPh6+ngZvBHgfBaVz4O9/wc
// SIG // fw91QDZnTgK9zAh9yRKKls2bziPEnxeOZMVNaxyV0v15
// SIG // 2PY2xjqIafIkUjK6vY9LtVFjJXenVUAmn3WCPWNFC1YT
// SIG // IIHw/mD2cTfPy7QA1pT+GPARAKt0bKtq9aCd/Ym0b5tP
// SIG // bpgCiRtzyb7fbNS1dE740re0COE67YV2wbeo2sXixzvL
// SIG // ftH8L7s9xv9wV+G22qyKt6lmKLjFK1yMw4Ni5fMabcgm
// SIG // zRvSjAcbqgp3tk4a8emaaH0rz8MuuIP+yrxtREPXSqL/
// SIG // C5bzMzsikuDW9xH10graZzSmPjilzpRfRdu20/9UQmC7
// SIG // eVPZ4j1WNa1oqPHfzET3ChIzJ6Q9G3NPCB+7KwX0OQmK
// SIG // yv7IDimj8U/GlsHD1z+EF/fYMf8YXG15LamaOAohsw/y
// SIG // wO6SYSreVW+5Y0mzJutnBC9Cm9ozj1+/4kqksrlhZgR/
// SIG // CSxhFH3BTweH8gP2FEISRtShDZbuYymynY1un+RyfiK9
// SIG // +iVTLdD1h/SxyxDpZMtimb4CgJQlMYIZNDCCGTACAQEw
// SIG // WDBBMRMwEQYKCZImiZPyLGQBGRYDR0JMMRMwEQYKCZIm
// SIG // iZPyLGQBGRYDQU1FMRUwEwYDVQQDEwxBTUUgQ1MgQ0Eg
// SIG // MDECEzYAAAGp1pAwZkPbH4IAAgAAAakwDQYJYIZIAWUD
// SIG // BAIBBQCgga4wGQYJKoZIhvcNAQkDMQwGCisGAQQBgjcC
// SIG // AQQwHAYKKwYBBAGCNwIBCzEOMAwGCisGAQQBgjcCARUw
// SIG // LwYJKoZIhvcNAQkEMSIEIEHftOUXf7MeKlWjphSgba5n
// SIG // Es3Q4TQrE4PDTJ9b/pYGMEIGCisGAQQBgjcCAQwxNDAy
// SIG // oBSAEgBNAGkAYwByAG8AcwBvAGYAdKEagBhodHRwOi8v
// SIG // d3d3Lm1pY3Jvc29mdC5jb20wDQYJKoZIhvcNAQEBBQAE
// SIG // ggEATGzv7euZ/e/KBVuUZAlmooQmjdbbgkSIi1ISb1dz
// SIG // 36DOCjp8P1ITVplXTzeyMldnvatf6LcbRyZWCKXSU/8g
// SIG // pvyy/luug7eRzxWfUifPueaaTfGXnIsglfIyZv68TKdF
// SIG // igDAhn/bpZ8jj+CIjMY2rj4UPIqv5TBDP1hGIv5QhItN
// SIG // Mz0IC8UJvnScVKTFXbRwk5bqdll7pb0Z5OPh9GjZOa35
// SIG // rVk8DMAtyQ9MrqdI7rThGbt3H5AfkYL0WvuG0Bci1owj
// SIG // tYVzlZSa5bENwneKEY9usK4fr3MrTcw9K9huBsFWDkBA
// SIG // s4D23ilHBDy4WcaA7ZUndkM031nuR8DfBqEdMKGCFvww
// SIG // ghb4BgorBgEEAYI3AwMBMYIW6DCCFuQGCSqGSIb3DQEH
// SIG // AqCCFtUwghbRAgEDMQ8wDQYJYIZIAWUDBAIBBQAwggFQ
// SIG // BgsqhkiG9w0BCRABBKCCAT8EggE7MIIBNwIBAQYKKwYB
// SIG // BAGEWQoDATAxMA0GCWCGSAFlAwQCAQUABCDy1qHqbpVI
// SIG // 7jPZBL4w3UUZENIGgzT/ttSC2W4ZvzFXhAIGY7/yQOAG
// SIG // GBIyMDIzMDIwNjEzMDE0Ni43MlowBIACAfSggdCkgc0w
// SIG // gcoxCzAJBgNVBAYTAlVTMRMwEQYDVQQIEwpXYXNoaW5n
// SIG // dG9uMRAwDgYDVQQHEwdSZWRtb25kMR4wHAYDVQQKExVN
// SIG // aWNyb3NvZnQgQ29ycG9yYXRpb24xJTAjBgNVBAsTHE1p
// SIG // Y3Jvc29mdCBBbWVyaWNhIE9wZXJhdGlvbnMxJjAkBgNV
// SIG // BAsTHVRoYWxlcyBUU1MgRVNOOkREOEMtRTMzNy0yRkFF
// SIG // MSUwIwYDVQQDExxNaWNyb3NvZnQgVGltZS1TdGFtcCBT
// SIG // ZXJ2aWNloIIRVDCCBwwwggT0oAMCAQICEzMAAAHFA83N
// SIG // IaH07zkAAQAAAcUwDQYJKoZIhvcNAQELBQAwfDELMAkG
// SIG // A1UEBhMCVVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAO
// SIG // BgNVBAcTB1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29m
// SIG // dCBDb3Jwb3JhdGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0
// SIG // IFRpbWUtU3RhbXAgUENBIDIwMTAwHhcNMjIxMTA0MTkw
// SIG // MTMyWhcNMjQwMjAyMTkwMTMyWjCByjELMAkGA1UEBhMC
// SIG // VVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcT
// SIG // B1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jw
// SIG // b3JhdGlvbjElMCMGA1UECxMcTWljcm9zb2Z0IEFtZXJp
// SIG // Y2EgT3BlcmF0aW9uczEmMCQGA1UECxMdVGhhbGVzIFRT
// SIG // UyBFU046REQ4Qy1FMzM3LTJGQUUxJTAjBgNVBAMTHE1p
// SIG // Y3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2UwggIiMA0G
// SIG // CSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQCrSF2zvR5f
// SIG // bcnulqmlopdGHP5NPsknc69V/f43x82nFGzmNjiES/cF
// SIG // X/DkRZdtl07ibfGPTWVMj/EOSr7K2O6I97zEZexnEOe2
// SIG // /svUTMx3mMhKon55i7ySBXTnqaqzx0GjnnFk889zF/m7
// SIG // X3OfThoxAXk9dX8LhktKMVr0gU1yuJt06beUZbWtBEVr
// SIG // aNSy6nqC/rfirlTAfT1YYa7TPz1Fu1vIznm+YGBZXx53
// SIG // ptkJmtyhgiMwvwVFO8aXOeqboe3Bl1czAodPdr+QtRI+
// SIG // IYCysiATPPs2kGl46yCz1OvDJZNkE1sHDIgAKZDfiP65
// SIG // Hh63aFmT40fj0qEQnJgPb504hoMYHYRQ0VJhzLUySC1m
// SIG // 3V5GoEHSb5g9jPseOhw/KQpg1BntO/7OCU598KJrHWM5
// SIG // vS7ohgLlfUmvwDBNyxoPK7eoCHHxwVA30MOCJVnD5REV
// SIG // nyjKgOTqwhXWfHnNkvL6E21qR49f1LtjyfWpZ8COhc8T
// SIG // orT91tPDzsQ4kv8GUkZwqgVPK2vTM+D8w0lJvp/Zr/AO
// SIG // RegYIZYmJCsZPGM4/5H3r+cggbTl4TUumTLYU51gw8Hg
// SIG // OFbu0F1lq616lNO5KGaCf4YoRHwCgDWBJKTUQLllfhym
// SIG // lWeAmluUwG7yv+0KF8dV1e+JjqENKEfBAKZmpl5uBJge
// SIG // ceXi6sT7grpkLwIDAQABo4IBNjCCATIwHQYDVR0OBBYE
// SIG // FFTquzi/WbE1gb+u2kvCtXB6TQVrMB8GA1UdIwQYMBaA
// SIG // FJ+nFV0AXmJdg/Tl0mWnG1M1GelyMF8GA1UdHwRYMFYw
// SIG // VKBSoFCGTmh0dHA6Ly93d3cubWljcm9zb2Z0LmNvbS9w
// SIG // a2lvcHMvY3JsL01pY3Jvc29mdCUyMFRpbWUtU3RhbXAl
// SIG // MjBQQ0ElMjAyMDEwKDEpLmNybDBsBggrBgEFBQcBAQRg
// SIG // MF4wXAYIKwYBBQUHMAKGUGh0dHA6Ly93d3cubWljcm9z
// SIG // b2Z0LmNvbS9wa2lvcHMvY2VydHMvTWljcm9zb2Z0JTIw
// SIG // VGltZS1TdGFtcCUyMFBDQSUyMDIwMTAoMSkuY3J0MAwG
// SIG // A1UdEwEB/wQCMAAwEwYDVR0lBAwwCgYIKwYBBQUHAwgw
// SIG // DQYJKoZIhvcNAQELBQADggIBAIyo3nx+swc5JxyIr4J2
// SIG // evp0rx9OyBAN5n1u9CMK7E0glkn3b7Gl4pEJ/derjup1
// SIG // HKSQpSdkLp0eEvC3V+HDKLL8t91VD3J/WFhn9GlNL7PS
// SIG // Gdqgr4/8gMCJQ2bfY1cuEMG7Q/hJv+4JXiM641RyYmGm
// SIG // kFCBBWEXH/nsliTUsJ2Mh57/8atx9uRC2Jihv05r3cNK
// SIG // NuwPWOpqJwSeRyVQ3+YSb1mycKcDX785AOn/xDhw98f3
// SIG // gszgnpfQ200F5XLC9YfTC4xo4nMeAMsJ4lSQUT0cTywE
// SIG // NV52aPrM8kAj7ujMuNirDuLhEVuJK19ZlIaPC36UslBl
// SIG // FZQJxPdodi9OjVhYNmySiFaDvvD18XZBuI70N+eqhntC
// SIG // jMeLtGI+luOCQkwCGuGl5N/9q3Z734diQo5tSaA8CsfV
// SIG // aOK/CbV3s9haxqsvu7mpm6TfoZvWYRNLWgDZdff4LeuC
// SIG // 3NGiE/z2plV/v2VW+OaDfg20gIr+kyT31IG62CG2KkVI
// SIG // xB1tdSdLah4u31wq6/Uwm76AnzepdM2RDZCqHG01G9sT
// SIG // 1CqaolDDlVb/hJnN7Wk9fHI5M7nIOr6JEhS5up5DOZRw
// SIG // KSLI24IsdaHw4sIjmYg4LWIu1UN/aXD15auinC7lIMm1
// SIG // P9nCohTWpvZT42OQ1yPWFs4MFEQtpNNZ33VEmJQj2dwm
// SIG // QaD+MIIHcTCCBVmgAwIBAgITMwAAABXF52ueAptJmQAA
// SIG // AAAAFTANBgkqhkiG9w0BAQsFADCBiDELMAkGA1UEBhMC
// SIG // VVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcT
// SIG // B1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jw
// SIG // b3JhdGlvbjEyMDAGA1UEAxMpTWljcm9zb2Z0IFJvb3Qg
// SIG // Q2VydGlmaWNhdGUgQXV0aG9yaXR5IDIwMTAwHhcNMjEw
// SIG // OTMwMTgyMjI1WhcNMzAwOTMwMTgzMjI1WjB8MQswCQYD
// SIG // VQQGEwJVUzETMBEGA1UECBMKV2FzaGluZ3RvbjEQMA4G
// SIG // A1UEBxMHUmVkbW9uZDEeMBwGA1UEChMVTWljcm9zb2Z0
// SIG // IENvcnBvcmF0aW9uMSYwJAYDVQQDEx1NaWNyb3NvZnQg
// SIG // VGltZS1TdGFtcCBQQ0EgMjAxMDCCAiIwDQYJKoZIhvcN
// SIG // AQEBBQADggIPADCCAgoCggIBAOThpkzntHIhC3miy9ck
// SIG // eb0O1YLT/e6cBwfSqWxOdcjKNVf2AX9sSuDivbk+F2Az
// SIG // /1xPx2b3lVNxWuJ+Slr+uDZnhUYjDLWNE893MsAQGOhg
// SIG // fWpSg0S3po5GawcU88V29YZQ3MFEyHFcUTE3oAo4bo3t
// SIG // 1w/YJlN8OWECesSq/XJprx2rrPY2vjUmZNqYO7oaezOt
// SIG // gFt+jBAcnVL+tuhiJdxqD89d9P6OU8/W7IVWTe/dvI2k
// SIG // 45GPsjksUZzpcGkNyjYtcI4xyDUoveO0hyTD4MmPfrVU
// SIG // j9z6BVWYbWg7mka97aSueik3rMvrg0XnRm7KMtXAhjBc
// SIG // TyziYrLNueKNiOSWrAFKu75xqRdbZ2De+JKRHh09/SDP
// SIG // c31BmkZ1zcRfNN0Sidb9pSB9fvzZnkXftnIv231fgLrb
// SIG // qn427DZM9ituqBJR6L8FA6PRc6ZNN3SUHDSCD/AQ8rdH
// SIG // GO2n6Jl8P0zbr17C89XYcz1DTsEzOUyOArxCaC4Q6oRR
// SIG // RuLRvWoYWmEBc8pnol7XKHYC4jMYctenIPDC+hIK12Nv
// SIG // DMk2ZItboKaDIV1fMHSRlJTYuVD5C4lh8zYGNRiER9vc
// SIG // G9H9stQcxWv2XFJRXRLbJbqvUAV6bMURHXLvjflSxIUX
// SIG // k8A8FdsaN8cIFRg/eKtFtvUeh17aj54WcmnGrnu3tz5q
// SIG // 4i6tAgMBAAGjggHdMIIB2TASBgkrBgEEAYI3FQEEBQID
// SIG // AQABMCMGCSsGAQQBgjcVAgQWBBQqp1L+ZMSavoKRPEY1
// SIG // Kc8Q/y8E7jAdBgNVHQ4EFgQUn6cVXQBeYl2D9OXSZacb
// SIG // UzUZ6XIwXAYDVR0gBFUwUzBRBgwrBgEEAYI3TIN9AQEw
// SIG // QTA/BggrBgEFBQcCARYzaHR0cDovL3d3dy5taWNyb3Nv
// SIG // ZnQuY29tL3BraW9wcy9Eb2NzL1JlcG9zaXRvcnkuaHRt
// SIG // MBMGA1UdJQQMMAoGCCsGAQUFBwMIMBkGCSsGAQQBgjcU
// SIG // AgQMHgoAUwB1AGIAQwBBMAsGA1UdDwQEAwIBhjAPBgNV
// SIG // HRMBAf8EBTADAQH/MB8GA1UdIwQYMBaAFNX2VsuP6KJc
// SIG // YmjRPZSQW9fOmhjEMFYGA1UdHwRPME0wS6BJoEeGRWh0
// SIG // dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9wa2kvY3JsL3By
// SIG // b2R1Y3RzL01pY1Jvb0NlckF1dF8yMDEwLTA2LTIzLmNy
// SIG // bDBaBggrBgEFBQcBAQROMEwwSgYIKwYBBQUHMAKGPmh0
// SIG // dHA6Ly93d3cubWljcm9zb2Z0LmNvbS9wa2kvY2VydHMv
// SIG // TWljUm9vQ2VyQXV0XzIwMTAtMDYtMjMuY3J0MA0GCSqG
// SIG // SIb3DQEBCwUAA4ICAQCdVX38Kq3hLB9nATEkW+Geckv8
// SIG // qW/qXBS2Pk5HZHixBpOXPTEztTnXwnE2P9pkbHzQdTlt
// SIG // uw8x5MKP+2zRoZQYIu7pZmc6U03dmLq2HnjYNi6cqYJW
// SIG // AAOwBb6J6Gngugnue99qb74py27YP0h1AdkY3m2CDPVt
// SIG // I1TkeFN1JFe53Z/zjj3G82jfZfakVqr3lbYoVSfQJL1A
// SIG // oL8ZthISEV09J+BAljis9/kpicO8F7BUhUKz/AyeixmJ
// SIG // 5/ALaoHCgRlCGVJ1ijbCHcNhcy4sa3tuPywJeBTpkbKp
// SIG // W99Jo3QMvOyRgNI95ko+ZjtPu4b6MhrZlvSP9pEB9s7G
// SIG // dP32THJvEKt1MMU0sHrYUP4KWN1APMdUbZ1jdEgssU5H
// SIG // LcEUBHG/ZPkkvnNtyo4JvbMBV0lUZNlz138eW0QBjloZ
// SIG // kWsNn6Qo3GcZKCS6OEuabvshVGtqRRFHqfG3rsjoiV5P
// SIG // ndLQTHa1V1QJsWkBRH58oWFsc/4Ku+xBZj1p/cvBQUl+
// SIG // fpO+y/g75LcVv7TOPqUxUYS8vwLBgqJ7Fx0ViY1w/ue1
// SIG // 0CgaiQuPNtq6TPmb/wrpNPgkNWcr4A245oyZ1uEi6vAn
// SIG // Qj0llOZ0dFtq0Z4+7X6gMTN9vMvpe784cETRkPHIqzqK
// SIG // Oghif9lwY1NNje6CbaUFEMFxBmoQtB1VM1izoXBm8qGC
// SIG // AsswggI0AgEBMIH4oYHQpIHNMIHKMQswCQYDVQQGEwJV
// SIG // UzETMBEGA1UECBMKV2FzaGluZ3RvbjEQMA4GA1UEBxMH
// SIG // UmVkbW9uZDEeMBwGA1UEChMVTWljcm9zb2Z0IENvcnBv
// SIG // cmF0aW9uMSUwIwYDVQQLExxNaWNyb3NvZnQgQW1lcmlj
// SIG // YSBPcGVyYXRpb25zMSYwJAYDVQQLEx1UaGFsZXMgVFNT
// SIG // IEVTTjpERDhDLUUzMzctMkZBRTElMCMGA1UEAxMcTWlj
// SIG // cm9zb2Z0IFRpbWUtU3RhbXAgU2VydmljZaIjCgEBMAcG
// SIG // BSsOAwIaAxUAIQAa9hdkkrtxSjrb4u8RhATHv+eggYMw
// SIG // gYCkfjB8MQswCQYDVQQGEwJVUzETMBEGA1UECBMKV2Fz
// SIG // aGluZ3RvbjEQMA4GA1UEBxMHUmVkbW9uZDEeMBwGA1UE
// SIG // ChMVTWljcm9zb2Z0IENvcnBvcmF0aW9uMSYwJAYDVQQD
// SIG // Ex1NaWNyb3NvZnQgVGltZS1TdGFtcCBQQ0EgMjAxMDAN
// SIG // BgkqhkiG9w0BAQUFAAIFAOeLZJswIhgPMjAyMzAyMDYx
// SIG // OTM1NTVaGA8yMDIzMDIwNzE5MzU1NVowdDA6BgorBgEE
// SIG // AYRZCgQBMSwwKjAKAgUA54tkmwIBADAHAgEAAgINIjAH
// SIG // AgEAAgISezAKAgUA54y2GwIBADA2BgorBgEEAYRZCgQC
// SIG // MSgwJjAMBgorBgEEAYRZCgMCoAowCAIBAAIDB6EgoQow
// SIG // CAIBAAIDAYagMA0GCSqGSIb3DQEBBQUAA4GBAIcliUjc
// SIG // VlhNg7F4Ky7gO+v28Ob7//rDQPDGwdJttRfaVmk/kq9V
// SIG // eXnsHtOH977wM+cXwZ8Q3rSw6rAKfc+QOgGeXN/eFIWg
// SIG // wIMwN3BvCAP2eirYfmZ8BYL10Quo1HrB4/Foh9dmKukX
// SIG // SkS7J8Jhb6Z+61ZczrODKKIqXsddfNcVMYIEDTCCBAkC
// SIG // AQEwgZMwfDELMAkGA1UEBhMCVVMxEzARBgNVBAgTCldh
// SIG // c2hpbmd0b24xEDAOBgNVBAcTB1JlZG1vbmQxHjAcBgNV
// SIG // BAoTFU1pY3Jvc29mdCBDb3Jwb3JhdGlvbjEmMCQGA1UE
// SIG // AxMdTWljcm9zb2Z0IFRpbWUtU3RhbXAgUENBIDIwMTAC
// SIG // EzMAAAHFA83NIaH07zkAAQAAAcUwDQYJYIZIAWUDBAIB
// SIG // BQCgggFKMBoGCSqGSIb3DQEJAzENBgsqhkiG9w0BCRAB
// SIG // BDAvBgkqhkiG9w0BCQQxIgQgBRaMFaW5E3De3ksITucK
// SIG // OCnODm1/WC8KLrQTJC/L8TowgfoGCyqGSIb3DQEJEAIv
// SIG // MYHqMIHnMIHkMIG9BCAZAbGR9iR3TAr5XT3A7Sw76yby
// SIG // AAzKPkS4o+q81D98sTCBmDCBgKR+MHwxCzAJBgNVBAYT
// SIG // AlVTMRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQH
// SIG // EwdSZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQgQ29y
// SIG // cG9yYXRpb24xJjAkBgNVBAMTHU1pY3Jvc29mdCBUaW1l
// SIG // LVN0YW1wIFBDQSAyMDEwAhMzAAABxQPNzSGh9O85AAEA
// SIG // AAHFMCIEILrIMoUBKpXznxjENuXiXvztDbH52+IR6Emw
// SIG // Yy0Xk7lJMA0GCSqGSIb3DQEBCwUABIICAF24Y5XV4Kgv
// SIG // mVMadei4OSdXYPLm1eZGlbbfOFcsqsiiLFeJTS9dwx/J
// SIG // Hv3or0xuIBWPzGnShkU5rvKUeVS2Af5s2xQHHVDHW0W3
// SIG // 5I6cdDEIK14CZnmtzOHdKmG2d56v2suM50cULMgyQSlK
// SIG // ubO/S4h8SpHeTbBHPubKoslDMQmtS9RdELLlFnATVaa1
// SIG // 5WJzTm8hYqA9FGmQCj89lTe3HnOUXxWllRX2IDVdSehP
// SIG // 6y3lqPU0ME+TtSvaEgwFVFR16CGQNZaxFZ+wpltXoQtP
// SIG // jX4v/VOg4CDwya7H1bLdzX+XLnAa9u7JtESN5PZTB1mA
// SIG // LMEFrwpfjIFhI0TWMYvXpZLtqb7z2BpzKnrjwAn77El5
// SIG // iBtYmw2F7XOjkFEKRRDN3fI0HL9DhYkNGJARKCExytoD
// SIG // Aw086bqXGH6v5/dPt+huvNJhm0KBzPk1FNfS6EazT0lW
// SIG // JbRNJdm5tF9saVUYPxiEG2fElGuzsIrqGXfgiuIFBhuo
// SIG // Wj4ofvL0MYqveuhRNEJHlPJvZYMHNGoNaZrX7Q0H7Rns
// SIG // tmme5GZdiGh9t/vpHer9YdMIqGbyL3YMZWfh7i7pqZbg
// SIG // XSV7wxl+4k+RDwlyuSwolGuDEY9wXEUoPsP6Tfac/LU2
// SIG // Y43ocr8i5QfIDx/XjTMf+Zjl2rNABIspXnkzk8v2qV8O
// SIG // 0Nkrs1RZNTde
// SIG // End signature block
